import type { TokenPayload } from './tokenTypes';

const CLAIM_KEYS = ['claims', 'permissions', 'scope', 'cognito:groups'] as const;

export const extractClaimsFromPayload = (payload: TokenPayload): string[] => {
    const extractedClaims = new Set<string>();

    for (const key of CLAIM_KEYS) {
        const payloadValues = payload[key];

        if (Array.isArray(payloadValues)) {
            payloadValues.forEach(payloadValue => payloadValue.trim() && extractedClaims.add(payloadValue.trim()));
            continue;
        }

        if (typeof payloadValues === 'string') {
            payloadValues.split(/\s+/).forEach(payloadValue => payloadValue && extractedClaims.add(payloadValue));
            continue;
        }

        if (payloadValues && typeof payloadValues === 'object') {
            for (const [k, val] of Object.entries(payloadValues)) {
                const truthy =
                    val === true ||
                    (typeof val === 'number' && val !== 0) ||
                    (typeof val === 'string' && val.length > 0);
                if (truthy) {
                    extractedClaims.add(k);
                }
            }
        }
    }

    return Array.from(extractedClaims);
};
